import { Box, Container } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { FunctionComponent, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AlertModel } from '../../model/Alert.model';
import { BusinessContextModel } from '../../model/BusinessContext.model';
import { ConfirmationModel } from '../../model/Confirmation.model';
import { AppAlert } from '../AppAlert/AppAlert';
import { AppContextProvider } from '../AppContextProvider/AppContextProvider';
import { AppQueryClientProvider } from '../AppQueryClientProvider/AppQueryClientProvider';
import { AppRouter } from '../AppRouter/AppRouter';
import { AppTheme } from '../AppTheme/AppTheme';
import { BackdropLoader } from '../BackdropLoader/BackdropLoader';
import { ConfirmationDialog } from '../ConfirmationDialog/ConfirmationDialog';
import { DesktopHeaderMenu } from '../DesktopHeaderMenu/DesktopHeaderMenu';
import { DesktopSidebarMenu } from '../DesktopSidebarMenu/DesktopSidebarMenu';
import { MobileHeaderMenu } from '../MobileHeaderMenu/MobileHeaderMenu';
import { RedirectPage } from '../RedirectPage/RedirectPage';

export const App: FunctionComponent = () => {
  const [loaderVisible, setLoaderVisible] = useState<boolean>(false);
  const [alert, showAlert] = useState<AlertModel | null>(null);
  const [confirmation, setConfirmation] = useState<ConfirmationModel | null>(null);
  const [businessContext, setBusinessContext] = useState<BusinessContextModel | null>(null);
  const [customerId, setCustomerId] = useState<number | null>(null);
  const { initialized: keycloakInitialized } = useKeycloak();

  return keycloakInitialized
    ? <AppTheme>
      <AppContextProvider
        setLoaderVisibility={setLoaderVisible}
        showAlert={showAlert}
        showConfirmationDialog={setConfirmation}
        setBusinessContext={setBusinessContext}
        businessContext={businessContext}
        setCustomerId={setCustomerId}
        customerId={customerId}
      >
        <AppQueryClientProvider businessContext={businessContext}>
          <BrowserRouter>
            <Container
              disableGutters
              maxWidth={false}
              sx={{
                display: 'flex',
                width: '100%',
                height: '100vh',
                flexDirection: { xs: 'column', sm: 'row' },
                padding: 0,
                overflow: 'hidden',
              }}
            >
              <BackdropLoader loaderVisible={loaderVisible} />
              <AppAlert
                alert={alert}
                showAlert={showAlert}
              />
              <ConfirmationDialog
                confirmation={confirmation}
                closeDialog={() => setConfirmation(null)}
              />
              <MobileHeaderMenu />
              <DesktopSidebarMenu />
              <Container
                disableGutters
                maxWidth={false}
                sx={{
                  width: '100%',
                  height: { xs: 'calc(100vh - 64px)', sm: '100%' },
                  p: 0,
                }}
              >
                <Box sx={{ height: '100%', overflowY: 'auto', position: 'relative' }}>
                  <DesktopHeaderMenu />
                  <AppRouter />
                </Box>
              </Container>
            </Container>
          </BrowserRouter>
        </AppQueryClientProvider>
      </AppContextProvider>
    </AppTheme>
    : <RedirectPage />;
};